'use client';

import React, { useState } from 'react';
import Image from 'next/image';

interface AccordionItem {
  title: string | React.ReactNode;
  content: string | React.ReactNode;
}

interface AccordionProps {
  items: AccordionItem[];
  className?: string;
  titleClassName?: string;
  titleStyle?: React.CSSProperties;
  contentClassName?: string;
}

const Accordion: React.FC<AccordionProps> = ({
  items,
  className = '',
  titleClassName = '',
  titleStyle,
  contentClassName = 'px-4',
}) => {
  const [expandedItems, setExpandedItems] = useState<number[]>([]);

  const toggleItem = (index: number) => {
    setExpandedItems(prev => 
      prev.includes(index) 
        ? prev.filter(i => i !== index)
        : [...prev, index]
    );
  };

  return (
    <div data-component-id="src/components/ui/Accordion.tsx:37:4" data-component-path="src/components/ui/Accordion.tsx" data-component-line="37" data-component-file="Accordion.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%7D" className={`flex flex-col w-full ${className}`}>
      {items.map((item, index) => (
        <div data-component-id="src/components/ui/Accordion.tsx:39:8" data-component-path="src/components/ui/Accordion.tsx" data-component-line="39" data-component-file="Accordion.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22w-full%20border-b%20border-%5B%233D1C1A%5D%20last%3Aborder-b-0%22%7D" key={index} className="w-full border-b border-[#3D1C1A] last:border-b-0">
          {/* Header */}
          <div data-component-id="src/components/ui/Accordion.tsx:41:10" data-component-path="src/components/ui/Accordion.tsx" data-component-line="41" data-component-file="Accordion.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22flex%20flex-row%20items-center%20justify-between%20py-4%20cursor-pointer%20transition-colors%20duration-200%22%7D" 
            className="flex flex-row items-center justify-between py-4 cursor-pointer transition-colors duration-200"
            onClick={() => toggleItem(index)}
          >
            <h3 data-component-id="src/components/ui/Accordion.tsx:45:12" data-component-path="src/components/ui/Accordion.tsx" data-component-line="45" data-component-file="Accordion.tsx" data-component-name="h3" data-component-content="%7B%22elementName%22%3A%22h3%22%7D"
              className={`flex-1 pr-4 text-[#3D1C1A] font-tt-norms-extra-black text-base leading-[21px] ${titleClassName}`}
              style={titleStyle}
            >
              {item.title}
            </h3>
            <Image data-component-id="src/components/ui/Accordion.tsx:51:12" data-component-path="src/components/ui/Accordion.tsx" data-component-line="51" data-component-file="Accordion.tsx" data-component-name="Image" data-component-content="%7B%22elementName%22%3A%22Image%22%2C%22alt%22%3A%22Toggle%22%7D" 
              src={expandedItems.includes(index) ? "/images/img_arrowdown_gray_900.svg" : "/images/img_arrowdown_gray_900.svg"}
              alt="Toggle" 
              width={16} 
              height={9}
              className={`transition-transform duration-200 ${expandedItems.includes(index) ? 'rotate-180' : ''}`}
            />
          </div>
          
          {/* Expandable Content */}
          {expandedItems.includes(index) && (
            <div data-component-id="src/components/ui/Accordion.tsx:62:12" data-component-path="src/components/ui/Accordion.tsx" data-component-line="62" data-component-file="Accordion.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%7D" className={`pb-4 ${contentClassName}`}>
              {typeof item.content === 'string' ? (
                <p data-component-id="src/components/ui/Accordion.tsx:64:16" data-component-path="src/components/ui/Accordion.tsx" data-component-line="64" data-component-file="Accordion.tsx" data-component-name="p" data-component-content="%7B%22elementName%22%3A%22p%22%2C%22className%22%3A%22text-%5B%233D1C1A%5D%20font-tt-norms-medium%20text-base%20leading-%5B21px%5D%20whitespace-pre-line%22%7D" className="text-[#3D1C1A] font-tt-norms-medium text-base leading-[21px] whitespace-pre-line">
                  {item.content}
                </p>
              ) : (
                item.content
              )}
            </div>
          )}
        </div>
      ))}
    </div>
  );
};

export default Accordion; 